import React, { FC, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

export const AutoLink: FC<{
  readonly children: ReactNode;
  readonly link: string;
  readonly matchUrlPrefix?: boolean;
  readonly newTab: boolean;
  readonly onClick: () => void;
}> = ({ link, onClick, children, newTab, matchUrlPrefix = true }) => {
  const regex = /^https?:\/\//;
  if (regex.test(link)) {
    return (
      <a
        href={link}
        onClick={onClick}
        // Allow the referrer if its being opened in the same tab
        rel={newTab ? 'noreferrer' : undefined}
        target={newTab ? '_blank' : undefined}
      >
        {children}
      </a>
    );
  }

  return (
    <NavLink activeClassName="active" exact={matchUrlPrefix} onClick={onClick} to={link}>
      {children}
    </NavLink>
  );
};
